import React from 'react';
import { baseURL } from 'config/api.js';
import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
//import './materialIssues.css';
import { AuthContext } from '../../context/AuthContext.jsx';
import { useContext } from 'react';
import Layout from 'components/global/Layout';
import { FaPlus } from 'react-icons/fa6';
import Loader from 'components/global/Loader';
import { toast } from 'react-toastify';
import Pagination from 'components/global/pagination';

export const MaterialIssues = () => {
  const [message, setMessage] = useState(null);
  const [category, setCategory] = useState("allCategories");
  const [categories, setCategories] = useState(null);
  const [totalMaterialIssueSlips, setTotalMaterialIssueSlips] = useState(null);
  const [materialIssues, setMaterialIssues] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const { userData } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  let page = parseInt(searchParams.get('page'));
  if (isNaN(page))
    page = 1;

  const handleCurrentPageChange = (page) => {
    searchParams.set('page', page);
    setSearchParams(searchParams);
  }

  async function fetchData() {
    let url = `${baseURL}/materialissues?page=${page}`;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };
    const response = await fetch(url, {
      method: "GET",
      headers: headers
    });
    const jsonData = await response.json();
    if (!response.ok) {
      toast.error(jsonData.data.message);
      setMessage(jsonData.data.message);
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }
    const materialIssues = jsonData.data.docs;

    let getCategoriesURL = baseURL + "/stockcategories";
    const getCategoriesResponse = await fetch(getCategoriesURL, {
      method: "GET",
      headers: headers
    });
    const getCategoriesJSONData = await getCategoriesResponse.json();
    if (!getCategoriesResponse.ok) {
      toast.error(getCategoriesJSONData.data.message);
      setMessage(getCategoriesJSONData.data.message);
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }
    const categories = getCategoriesJSONData.data.docs;

    setMaterialIssues(materialIssues);
    setTotalMaterialIssueSlips(jsonData.data.docsCount);
    setCategories(categories);
    setIsLoading(false)
  }

  const handleCategoryChange = async (e) => {
    if (!isLoading) {
      setIsLoading(true);
    }

    setCategory(e.target.value);

    let url;
    if (e.target.value === "allCategories")
      url = `${baseURL}/materialissues?page=${page}`;
    else
      url = `${baseURL}/materialissues?stockCategoryID=${e.target.value}&page=${page}`;

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };
    const response = await fetch(url, {
      method: "GET",
      headers: headers
    });
    const jsonData = await response.json();
    const materialIssues = jsonData.data.docs;

    setMaterialIssues(materialIssues);
    setTotalMaterialIssueSlips(jsonData.data.docsCount);
    setIsLoading(false);
  }

  const handleDelete = () => {

  }

  useEffect(() => {
    fetchData().catch(e => {
      setIsLoading(false);
      setMessage("An error occurred while communicating with the server.");
      toast.error("An error occurred while communicating with the server.");
    });
    // eslint-disable-next-line
  }, [searchParams]);

  const NewDocumentLink =
    (
      userData.doc.isSuperAdmin ||
      userData.doc.isAdmin ||
      userData.role.create.includes("materialissues")
    ) &&
    <Link to="/materialissues/new">
      <button className='flex flex-row items-center bg-[#1A8650] text-white px-3 text-sm py-2 space-x-1 rounded-3xl'>
        <span><FaPlus /></span>
        <span>New Material Issue Slip</span>
      </button>
    </Link>

  if (isLoading || (!isLoading && isLoadingError)) {
    return (
      <Layout>
        <div className='space-y-4'>
          <div className='flex flex-row justify-between items-center px-3'>
            <h2 className='text-2xl text-primary font-bold'>Material Issue Slips</h2>
            {
              NewDocumentLink
            }
          </div>
          <div className='flex flex-row justify-start'>
            <div>
              {message && message}
            </div>
          </div>
          {isLoading && <Loader />}
        </div>
      </Layout>
    );
  }

  let materialIssuesList = [];

  if (materialIssues && materialIssues.length > 0) {
    materialIssuesList = materialIssues.map((materialIssue, index) => {
      return (
        <tr key={materialIssue._id}>
          <td className="text-gray-900 px-6 py-4 whitespace-nowrap">{materialIssue.materialIssueID}</td>
          <td className="text-gray-900 px-6 py-4 whitespace-nowrap">
            <Link className='text-white bg-primary rounded-[40px] p-2' to={`/projects/${materialIssue.projectObjectId._id}`}>
              {materialIssue.projectObjectId.projectName}
            </Link>
          </td>
          <td className="text-gray-900 px-6 py-4 whitespace-nowrap">{materialIssue.stockItemObjectId?.stockItemSKU}</td>
          <td className="text-gray-900 px-6 py-4 whitespace-nowrap">{materialIssue.stockItemObjectId?.stockItemName}</td>
          <td className="text-gray-900 px-6 py-4 whitespace-nowrap">{materialIssue.materialIssueDate.split('T')[0]}</td>
          <td className="text-gray-900 px-6 py-4 whitespace-nowrap">{materialIssue.materialIssueQuantity}</td>
        </tr>
      );
    });
  }
  if (materialIssues && materialIssues.length === 0) {
    materialIssuesList = (
      <tr>
        <td colspan={6} className="text-gray-900 px-6 py-4 whitespace-nowrap">
          No material issue slips found!
        </td>
      </tr>
    )
  }

  console.log("Before MaterialIssues() rendering");

  return (
    <Layout>
      <div className="space-y-4">

        <div className='flex flex-row justify-between items-center px-3'>

          <h2 className='text-2xl text-center text-primary font-bold'>Material Issue Slips</h2>

          <div className='flex flex-row gap-3 justify-around'>

            <div className='flex flex-row items-center bg-[#90288F] px-3 py-2 rounded-3xl'>
              <div className='flex flex-row items-center text-white text-sm space-x-1'>
                <select
                  name="category"
                  onChange={handleCategoryChange}
                  value={category}
                  className='bg-[#90288F] rounded-[40px] outline-none text-sm'
                >
                  <option value="allCategories">All Categories</option>
                  {
                    categories && categories.length !== 0 && categories.map((c, index) => {
                      return (
                        <option key={c._id} value={c._id}>{c.stockCategoryName}</option>
                      );
                    })
                  }
                </select>
              </div>
            </div>

            <div>
              {NewDocumentLink}
            </div>

          </div>

        </div>
        <div className='overflow-x-auto rounded-lg border border-[#6843BE]'>
          <table className="w-full table-auto overflow-x-auto ">
            <thead className="bg-lightSlate border-b text-[14px] border border-b-[#6843BE] rounded-lg">
              <tr>
                <th scope="col" className="font-medium text-primary px-6 py-4 text-left">ID</th>
                <th scope="col" className="font-medium text-primary px-6 py-4 text-left">Project</th>
                <th scope="col" className="font-medium text-primary px-6 py-4 text-left">Stock Item SKU</th>
                <th scope="col" className="font-medium text-primary px-6 py-4 text-left">Stock Item Name</th>
                <th scope="col" className="font-medium text-primary px-6 py-4 text-left">Issue Date</th>
                <th scope="col" className="font-medium text-primary px-6 py-4 text-left">Quantity Issued</th>
              </tr>
            </thead>
            <tbody className='text-[13px] p-4'>
              {materialIssuesList}
            </tbody>
            <tfoot className='w-full bg-lightSlate border border-b-[#6843BE] border-t-[#6843BE]'>
              <tr>
                <td colSpan='9' >
                  <Pagination
                    currentPage={page}
                    pageCount={Math.ceil(totalMaterialIssueSlips / pageSize)}
                    setPage={handleCurrentPageChange}
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </Layout>

  );
}
